import Section from '@pelckmans/elementis/components/section';
import { useTranslation } from 'react-i18next';
import PolicyAndConditions, { TABS } from '..';
import useDocumentTitle from '../../../hooks/useDocumentTitle';
import ConditionsContentNL from './ContentNL';
import ConditionsContentFR from './ContentFR';
import TabPanel from '@pelckmans/elementis/components/tabs/tab-panel';
import Tabs from '@pelckmans/elementis/components/tabs';

function Conditions() {
  const {
    t,
    i18n: { language },
  } = useTranslation();

  useDocumentTitle(t('PAGES.CONDITIONS.DOCUMENT_TITLE'));

  return (
    <PolicyAndConditions>
      <Tabs.TabsContent>
        <TabPanel id={TABS.CONDITIONS}>
          <Section title={t('PAGES.CONDITIONS.SECTION.TITLE')}>
            {language === 'nl' && <ConditionsContentNL />}
            {language === 'fr' && <ConditionsContentFR />}
          </Section>
        </TabPanel>
      </Tabs.TabsContent>
    </PolicyAndConditions>
  );
}

export default Conditions;
